import React from "react";
// import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
// import MicIcon from "@mui/icons-material/Mic";
// import TurnedInNotOutlinedIcon from "@mui/icons-material/TurnedInNotOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import Archive from "@mui/icons-material/MoveToInbox";
import EditIcon from "@mui/icons-material/Edit";
// import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// import NoticeTab from "./NoticeTab";
import CreateNoticeModal from "./CreateNoticeModal";
import { makePostRequest, makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";
// End
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TurnedInOutlinedIcon from "@mui/icons-material/TurnedInOutlined";
import PropTypes from "prop-types";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
// import FormControl from "@mui/material/FormControl";
// import FormLabel from "@mui/material/FormLabel";
import Zoom from "react-medium-image-zoom";
// import parse from "html-react-parser";
// import { Editor } from "@tinymce/tinymce-react";
import moment from "moment";
// import DownloadIcon from "@mui/icons-material/Download";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Print from "@mui/icons-material/Print";
import avtarPic from "../../../assets/Images/avtarPic.png";
import CallIcon from "@mui/icons-material/Call";
import jsPDF from "jspdf";
import ReactDOMServer from "react-dom/server";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import DoneIcon from "@mui/icons-material/Done";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import reecordNotFound from "../../../assets/Images/noData2.gif";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Pagination from "@mui/material/Pagination";
import ladyImg from "../../../assets/Images/society-new-logo.svg";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function NoticeBoardPage(props) {
  // const navigate = useNavigate();

  function opNotiBordLeft() {
    var element = document.getElementById("IdopNotiBordLeft");
    element.classList.toggle("opNotiBordLeftSt");
  }

  // New Modal
  const [sendforuser, setsendforuser] = React.useState([]);
  const [openSendFor, setOpenSendFor] = React.useState(false);

  const handleClickOpenSendFor = (scrollType, key) => () => {
    let memsend = key.member_id;
    console.log("aaa", memsend);
    setScroll(scrollType);
    if (memsend.length > 0) {
      setShowLoader(true);
      let inputdata = {
        id: memsend,
        eventId: 0,
      };

      makePostRequest("commonapis/getmembersData", inputdata)
        .then((response) => {
          if (response.status === 201) {
            setsendforuser(response.data.data.rows);
            setShowLoader(false);
            console.log(response.data.data.rows);
          } else {
            setShowLoader(false);
            swal("There was an error!", response.message, "warning");
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    } else {
      setsendforuser([]);
    }
    setOpenSendFor(true);
  };

  const handleCloseSendFor = () => {
    setOpenSendFor(false);
  };

  const descriptionElementRefSendFor = React.useRef(null);
  React.useEffect(() => {
    if (openSendFor) {
      const { current: descriptionElement } = descriptionElementRefSendFor;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [openSendFor]);
  // End

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);

  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = (e) => {
    setAnchorEl(null);
    if (e.currentTarget.dataset.myValue !== undefined) {
      setSort(e.currentTarget.dataset.myValue);
    }
    // getAllNotice("publish");
  };
  // End

  const [open2, setOpen2] = React.useState(false);

  const handleEditNotice = (scrollType, noticeId) => () => {
    localStorage.setItem("isEditNotice", true);
    localStorage.setItem("editNoticeId", noticeId);
    setOpen2(true);
    setScroll(scrollType);
  };

  const handleClose2 = () => {
    setOpen2(false);
    localStorage.removeItem("isEditNotice");
    localStorage.removeItem("editNoticeId");
  };

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [selectedItem, setSelectedItem] = React.useState([]);
  const [value, setValue] = React.useState(0);
  const [noticeData, setNoticeData] = React.useState([]);
  const [q, setQ] = React.useState("");
  const [membersIds, setMembersIds] = React.useState([]);
  const [radiovalue, setradioValue] = React.useState("");
  const [showbtn, setshowbtn] = React.useState(false);
  const [individualflg, setindividualflg] = React.useState(false);
  const [activeIndex, setActiveIndex] = React.useState(null);
  const [sort, setSort] = React.useState("");
  const [status, setStatus] = React.useState("publish");
  const [noticeDesc, setnoticeDesc] = React.useState(null);
  const [showLoader, setShowLoader] = React.useState(false);
  const memidRef = React.useRef(membersIds);
  const [ressearch, setressearch] = React.useState("");
  const [newdate, setnewDate] = React.useState(new Date());
  const [updategrp, setupdategrp] = React.useState(false);

  const [pdfImage, setPdfImage] = React.useState(
    require("../../../assets/Images/pdf.png")
  );
  const [txtImage, setTxtImage] = React.useState(
    require("../../../assets/Images/text.png")
  );
  const [excelImage, setExcelImage] = React.useState(
    require("../../../assets/Images/exel.png")
  );
  const [wordImage, setWordImage] = React.useState(
    require("../../../assets/Images/doc.png")
  );

  const MAX_LENGTH = 100;

  const [isIndividual, setIsIndividual] = React.useState();

  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage] = React.useState(5);
  const [totalItems, setTotalItems] = React.useState(0);

  let memberArr = [];

  const handlePageChange = (e, page) => {
    setCurrentPage(page);
  };

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue == 0) {
      localStorage.removeItem("noticeInfodash");
      getAllNotice("publish");
      setshowbtn(false);
    } else if (newValue == 1) {
      localStorage.removeItem("noticeInfodash");
      getAllNotice("draft");
      setshowbtn(true);
    } else {
      localStorage.removeItem("noticeInfodash");
      getAllNotice("archived");
      setshowbtn(false);
    }
  };

  const detailsNotice = async (keyinfo) => {
    console.log(keyinfo);
    setradioValue("");
    setIsIndividual(false);
    memberArr.length = 0;
    membersIds.length = 0;
    setSelectedItem(keyinfo);
    setActiveIndex(keyinfo.notice_id);
    localStorage.setItem("noticeInfoSave", JSON.stringify(keyinfo));
  };

  let setnoticeobj11 = {};
  async function getAllNotice(flag) {
    const camewithreadmore = localStorage.getItem("noticeInfodash");
    if (camewithreadmore !== null) {
      setnoticeobj11 = JSON.parse(camewithreadmore);
    }
    setShowLoader(true);
    setNoticeData([]);
    let bodyFormData = {
      searchq: q,
      pageNo: currentPage,
      count: itemsPerPage,
      notice_visible_flag: sort,
      status: flag,
    };

    await makePostRequest("commonapis/noticelisting", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          const data = response.data.data.data;
          if (data.length > 0) {
            setNoticeData(data);
            setTotalItems(response.data.data.total_records);
            if (camewithreadmore !== null) {
              detailsNotice(setnoticeobj11);
            } else {
              detailsNotice(response.data.data.data[0]);
            }
            // detailsNotice(response.data.data.rows[0]);
            setShowLoader(false);
          } else {
            setNoticeData([]);
            detailsNotice("");
          }
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  const [residentlist, setresidentlist] = React.useState([]);

  async function residentlisting() {
    let bodyFormData = {
      searchq: ressearch,
      pageNo: "",
      count: "",
      isTenent: "",
    };

    await makePostRequest("resident/residentandtenentlisting", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          // console.log(response.data.data.rows);
          // setlength(response.data.data.rowCount)
          const data = response.data.data.rows;
          setresidentlist(data);
          console.log(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handleChangeSelectedResident = (residentId) => {
    // membersIds.push(residentId);
    // setMembersIds(membersIds);
    let jsonarr = [];
    setMembersIds((memIds) => {
      const index = memIds.indexOf(residentId);
      if (index !== -1) {
        //remove
        const updatedIds = [...memIds];
        updatedIds.splice(index, 1);
        return updatedIds;
      } else {
        //add
        return [...memIds, residentId];
      }
    });
    // setActiveIndex(residentId);

    // console.log('indv ids',membersIds)
  };

  async function handleChangeradio(e) {
    memberArr.length = 0;
    membersIds.length = 0;
    setIsIndividual(false);

    let selectedVal = e.target.value;

    // alert(e.target.value)
    let userFlag = "";
    setradioValue(selectedVal);
    if (selectedVal == "individual") {
      setIsIndividual(true);
      // setupdategrp(!updategrp);
    } else {
      if (e.target.value === "Committee Members") {
        // setupdategrp(!updategrp);
        userFlag = "CommitteeMem";
      } else {
        // setupdategrp(!updategrp);
        userFlag = selectedVal;
      }
      setShowLoader(true);
      let bodyFormData = "";

      await makeGetRequest("post/getallMembersid/" + userFlag, bodyFormData)
        .then((response) => {
          if (response.status === 201) {
            for (var i = 0; i < response.data.data.length; i++) {
              memberArr.push(response.data.data[i].resident_id);
            }
            // console.log("ggg", memberArr);
            setMembersIds(memberArr);
            setupdategrp(!updategrp);
            setShowLoader(false);
          } else {
            setShowLoader(false);
            swal("There was an error!", response.message, "warning");
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    }
  }

  const handleChangeTabs = (flag) => {
    setCurrentPage(1);
    setSelectedItem("");
    setradioValue("");
    setStatus(flag);
    getAllNotice(flag);
    // setresidentlist([])
    setIsIndividual(false);
  };

  async function publishNotice(e, flgpass) {
    let dataval = localStorage.getItem("noticeInfoSave");
    let narr = JSON.parse(dataval);
    console.log("arr", narr);

    var inputdata = "";
    let flg = flgpass;

    inputdata = {
      notice_title: narr.notice_title,
      notice_description: narr.notice_description,
      attachment: narr.attachment,
      member_id: membersIds,
      notice_visible_flag: radiovalue,
    };

    await makePostRequest("commonapis/createNotice", inputdata)
      .then((response) => {
        if (response.data.status === "1") {
          swal("Success", "Notice sent successfully", "success", {
            timer: 1000,
            buttons: false,
          });
          window.location.reload();
          memberArr.length = 0;
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
        console.log("Something went wrong!!", err);
      });
  }

  async function updateNotice(statusval, nId) {
    // let dataval = localStorage.getItem("noticeInfoSave");
    // let narr = JSON.parse(dataval);
    let stval;
    if (statusval == "archrepublish") {
      stval = "republish";
    } else {
      stval = statusval;
    }

    const willDelete = await swal({
      title: "Are you sure?",
      text: `Do you really want to ${stval} this notice? This process cannot be undone.`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      setShowLoader(true);
      var inputdata = "";
      if (statusval === "archived") {
        // narr.status = status;
        // narr.archived_time = new Date();
        inputdata = {
          notice_id: nId,
          status: "archived",
          archived_time: new Date(),
        };
      } else if (statusval === "republish") {
        // nId = activeIndex
        // narr.status = "publish";
        // narr.created_at = new Date();
        inputdata = {
          notice_id: activeIndex,
          status: "publish",
          created_at: new Date(),
        };
      } else if (statusval === "archrepublish") {
        inputdata = {
          notice_id: nId,
          status: "publish",
          created_at: new Date(),
        };
      } else {
        // nId = activeIndex
        // narr.status = status;
        // narr.member_id = membersIds;
        // narr.notice_visible_flag = radiovalue;
        // narr.created_at = new Date();
        inputdata = {
          notice_id: activeIndex,
          status: "publish",
          member_id: membersIds,
          notice_visible_flag: radiovalue,
          created_at: new Date(),
        };
      }
      console.log("inputdata", inputdata);
      // return false;
      await makePostRequest("commonapis/updateNotice", inputdata)
        .then((response) => {
          if (response.status === 201) {
            swal("Success", "Notice sent successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            setShowLoader(false);
            // window.location.reload();
            memberArr.length = 0;
            setValue(0);
            setshowbtn(false);
            setIsIndividual(false);
            setStatus("publish");
            setradioValue("");
            getAllNotice("publish");
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
          console.log("Something went wrong!!", err);
        });
    }
  }

  //vehicle delete
  async function deleteNotice(noticeId) {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete these records? This process cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      var bodyFormData = new FormData();
      await makeGetRequest("commonapis/deleteNotice/" + noticeId)
        .then((response) => {
          if (response.data.status === "1") {
            swal("Success", "Notice Deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            // window.location.reload();
            // setValue(0);
            setStatus("draft");
            getAllNotice("draft");
            memberArr.length = 0;
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
          console.log("Something went wrong!!", err);
        });
    }
  }

  const handleFormSubmit = () => {
    handleClose();
    handleClose2();
    setValue(0);
    setStatus("publish");
    getAllNotice("publish");
    setIsIndividual(false);
  };

  // Kailas Changes
  const handlePrint = (keydata) => {
    // window.print();
    const printnotice = window.open("", "_blank");
    const cont = `<html>
    <head>
    <title>Notice</title>
    <style>
    @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100;200;300;400;500;600;700;800;900&display=swap');
    *{
      font-family: 'Outfit', sans-serif;
    }
    p{
      line-height: 30px;
    }
    @media print {
    .page-break{
        page-break-after: always;
        margin-bottom: 400px;
        width: 100%;
        float: left;
    }

    .page-break2{
        page-break-after: always;
        margin-bottom: 800px;
        width: 100%;
        float: left;
    }
      .common-header {
        position: fixed;
        top: 0;
        width: 100%;
        padding: 20px;
        background: #f2f2f2;
        text-align: center;
      }
      .notice-content {
        margin-top: 200px;
      }
         @page {
        margin-top: 0;
        margin-bottom: 0px;
      }
    }
    </style>
    </head>
      <body>
        <div className="width: 900px;
            max-width: 100%;
            background: #fff;
            margin: 0 auto;
            color: #000;
            text-align: center;
            text-align: center;
    ">
            <h2 style="color: #674BDD;letter-spacing: 4px;font-weight: 600;font-size: 25px;margin-bottom: 0;text-align: center;"><img src=${ladyImg} style="width: 121px;"
            /></h2>
            <h1 style="font-size: 25px;margin: 15px 0 20px;display: block;letter-spacing: 2px;text-transform: capitalize;text-align: center;"> 
              ${localStorage.getItem("societyName")} 
            </h1>
        </div>

        <div className="notice-content" 
              style="
                  position: relative;
                  width: 100%;               
                  padding: 20px;
                  border-radius: 15px;
                  text-align: left;
                  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.08);
                  box-sizing: border-box;
                  max-width: 1400px;
                  margin: 0 auto;
              ">

        
        <span style="
            font-size: 13px;
            width: 100%;
            float: left;
            margin: 15px 0 5px;
            font-weight: 600;
            letter-spacing: 1px;
            ">
            Notice No. ${"N" + keydata.notice_id}
        </span>
        
        <h2 style="
            font-size: 16px;
            margin: 5px 0;
            display: block;
            font-weight: 600;
            text-transform: capitalize;
            color: #000;
            letter-spacing: 1px;
            width: 100%;
            float: left;
            ">${keydata.notice_title} 
        </h2>
        
            <h4 style="
            font-size: 13px;
            margin: 5px 0 20px;
            display: block;
            letter-spacing: 1px;
            color: #4d4d4d;
            font-weight: 600;
            border-radius: 4px;    
            width: 100%;
            float: left;">
            ${moment(keydata.created_at).format("DD-MM-YYYY hh:mm A")}</h4>
            <div style=" font-size: 1px; display: block; width: 100%;">
                <span style="display: inline-block;width: 235px;height: 1px;background: #674bdd;border-radius: 11px;margin: 0 auto;"></span>
            </div>
            <p style="font-size: 14px;letter-spacing: 1px;line-height: 22px;color: #181515;">
            ${keydata.notice_description}
            </p>
            <b style="
              position: absolute;
              bottom: 35px;
              letter-spacing: 2px;
              font-size: 16px;
              color: #888;
              font-weight: 500;
              width: 100%;
              left: 0;
              text-align: right;
              padding: 0 45px;
              box-sizing: border-box;
              "
            >Powered by <span style="color: #674BDD;">ResiPro</span></b>
        </div>     
      </body>
    </html>`;
    printnotice.document.write(cont);
    printnotice.document.close();
    printnotice.print();
  };

  const handlePrint1 = (keydata) => {
    // console.log(keydata)
    let element = (
      <div style={{ width: "100%", float: "left" }}>
        <div
          style={{
            width: "900px",
            maxWidth: "94%",
            padding: "30px 3%",
            background: "#fff",
            margin: "0 auto",
            fontFamily: "Arial, Helvetica, sansSerif",
            color: "#000",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "32px", margin: "30px 0", display: "block" }}>
            Vasant vihar Housing Society
          </h1>
          <div
            style={{
              width: "92%",
              padding: "30px 4%",
              background: "#FFE711",
              borderRadius: "15px",
              margin: "0 auto",
            }}
          >
            <h2 style={{ fontSize: "25px", margin: "5 0", display: "block" }}>
              Title for the notice will be here
            </h2>
            <h4
              style={{
                fontSize: "16px",
                margin: "22px 0 30px",
                display: "block",
              }}
            >
              23-10-2023 10:00 pm
            </h4>
            <div style={{ fontSize: "1px", display: "block", width: "100%" }}>
              <span
                style={{
                  display: "inlineBlock",
                  width: "80px",
                  height: "3px",
                  background: "#000",
                  borderRadius: "4px",
                  margin: "0 auto",
                }}
              ></span>
            </div>
            <p
              style={{
                margin: "30px 0 20px",
                lineHeight: "30px",
                fontSize: "17px",
                fontWeight: "normal",
              }}
            >
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged. It was in
              the 1960s with the release of Letraset sheets containing Lorem
              Ipsum passages, and more recently with desktop publishing software
              like Aldus PageMaker including versions of Lorem Ipsum.
            </p>
          </div>
        </div>
      </div>
    );
    const doc = new jsPDF("p", "pt", "letter");
    doc.html(ReactDOMServer.renderToString(element), {
      callback: function (doc) {
        doc.save("sample.pdf");
      },
    });
  };

  let clkindex = null;
  const viewDocs = (nId, index) => {
    const btn = document.getElementById("noticeSlideID" + index);
    if (btn) {
      if (clkindex !== null) {
        const prevDivindex = document.getElementById(
          "noticeSlideID" + clkindex
        );
        if (prevDivindex) {
          prevDivindex.classList.remove("filesDiv");
        }
      }
      btn.classList.toggle("filesDiv");
      clkindex = index;
    }

    // clkindex = (clkindex === index) ? null : index

    // const priv = document.querySelector('.expandfilesDiv.filesDiv')
    // if (priv) {
    //   priv.classList.remove('filesDiv')
    // }
    // clkindex = index
    // const curr = document.getElementById("noticeSlideID" + index);

    // if (curr) {
    //   curr.classList.add('filesDiv')
    // }
  };

  React.useEffect(() => {
    if (q) {
      setCurrentPage(1);
    }
  }, [q]);

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    localStorage.removeItem("isEditNotice");
    localStorage.removeItem("editNoticeId");

    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    // setSort('')
    setSelectedItem("");
    // setStatus("publish");
    // getAllNotice("publish");
    getAllNotice(status);
    residentlisting();
    // console.log('membersIds', membersIds);
  }, [open, q, sort, ressearch, currentPage]);
  // End

  React.useEffect(() => {
    if (updategrp) {
      setupdategrp(false);
    }
  }, [updategrp, membersIds]);

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Notice Board</h1>
            {/* <Button className="contentTopLefBt contentTopLefBtSpc">
              Auto Archived
            </Button> */}

            <Button
              className="contentTopLefBt"
              onClick={handleClickOpen("body")}
            >
              Create Notice
            </Button>
          </Grid>

          <Grid item xs={12} md={12}>
            <div className="noticePageMain">
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <div className="visitorListNewInner">
                    <div className="visitorSearch">
                      <MenuOpenIcon
                        className="clickOpNotiBordLef"
                        onClick={opNotiBordLeft}
                      />
                      <div className="visitorSearchDiv">
                        <SearchIcon className="visitorSearchIco" />
                        <input
                          type="text"
                          placeholder="Search by notice title"
                          onChangeCapture={(e) => setQ(e.target.value)}
                        />
                        {/* <MicIcon className="visitorMicIco" /> */}
                      </div>
                      {status === "publish" && (
                        <SortIcon
                          className="visitorFilterIco"
                          aria-controls={openMenu ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={openMenu ? "true" : undefined}
                          onClick={handleClick}
                        />
                      )}
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={openMenu}
                        onClose={handleCloseMenu}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        <MenuItem onClick={handleCloseMenu} data-my-value={""}>
                          All Notice
                        </MenuItem>
                        <MenuItem
                          onClick={handleCloseMenu}
                          data-my-value={"all"}
                        >
                          All Members
                        </MenuItem>
                        <MenuItem
                          onClick={handleCloseMenu}
                          data-my-value={"allOwners"}
                        >
                          Owners
                        </MenuItem>
                        <MenuItem
                          onClick={handleCloseMenu}
                          data-my-value={"committeeMembers"}
                        >
                          Committee Members
                        </MenuItem>
                        <MenuItem
                          onClick={handleCloseMenu}
                          data-my-value={"individual"}
                        >
                          Individual
                        </MenuItem>
                      </Menu>
                    </div>

                    <div
                      id="IdopNotiBordLeft"
                      className="noticeTabMain responsivNoticeBoadrLeft"
                    >
                      {/* <NoticeTab /> */}
                      <CloseIcon
                        className="closeBNoticBordLeft"
                        onClick={opNotiBordLeft}
                      />
                      <Box sx={{ width: "100%" }}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                          <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="basic tabs example"
                          >
                            <Tab
                              label="Published"
                              {...a11yProps(0)}
                              onClick={() => handleChangeTabs("publish")}
                            />
                            <Tab
                              label="Drafts"
                              {...a11yProps(1)}
                              onClick={() => handleChangeTabs("draft")}
                            />
                            <Tab
                              label="Archived"
                              {...a11yProps(2)}
                              onClick={() => handleChangeTabs("archived")}
                            />
                          </Tabs>
                        </Box>
                        {/* for publish notice */}
                        <TabPanel
                          value={value}
                          index={0}
                          className="NoticeTabPanle"
                        >
                          <div className="noticeTbContDiv noticeNewMaster">
                            {noticeData.length > 0 ? (
                              <>
                                {noticeData.map((key, index) => (
                                  <div
                                    key={key.notice_id}
                                    className={
                                      key.notice_id === activeIndex
                                        ? "noticeTbContInner activeNotice"
                                        : "noticeTbContInner"
                                    }
                                    onClick={() => detailsNotice(key)}
                                    selectedItem={selectedItem}
                                  >
                                    <div className="downloadNotice">
                                      {/* {key.attachment.length > 0 && (
                                        <>
                                        {key.attachment.map((att) => (
                                        <a
                                          href={att}
                                          download
                                          target="_blank"
                                        >
                                          <Tooltip
                                            title={"Download Attachment"}
                                            arrow
                                            placement="top"
                                          >
                                            <IconButton aria-label="download">
                                              <DownloadIcon className="downLo" />
                                            </IconButton>
                                          </Tooltip>
                                        </a>
                                        ))}</>
                                      )} */}

                                      <Tooltip
                                        title="Print Notice"
                                        arrow
                                        placement="top"
                                      >
                                        <IconButton aria-label="download">
                                          <Print
                                            onClick={() => handlePrint(key)}
                                            className="printer"
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    </div>

                                    <p className="TicNoNotic newNotLabel">
                                      Notice No. {"N" + key.notice_id}
                                    </p>

                                    <h2 className="notTitleSt">
                                      {key.notice_title}
                                    </h2>
                                    {key.notice_visible_flag == "individual" ||
                                    key.notice_visible_flag ==
                                      "committeeMembers" ? (
                                      <span>
                                        Send for:{" "}
                                        <b
                                          onClick={handleClickOpenSendFor(
                                            "body",
                                            key
                                          )}
                                        >
                                          {key.notice_visible_flag}{" "}
                                          <RemoveRedEyeIcon />
                                        </b>
                                      </span>
                                    ) : (
                                      <span>
                                        Send for: {key.notice_visible_flag}
                                      </span>
                                    )}
                                    {key.archived_time ? (
                                      <span>
                                        Republished on:{" "}
                                        {moment(key.created_at).format(
                                          "DD-MM-YYYY hh:mm A"
                                        )}
                                      </span>
                                    ) : (
                                      <span>
                                        Published on:{" "}
                                        {moment(key.created_at).format(
                                          "DD-MM-YYYY hh:mm A"
                                        )}
                                      </span>
                                    )}

                                    {key.archived_time && (
                                      <span className="archivedDate">
                                        Archived on:{" "}
                                        {moment(key.archived_time).format(
                                          "DD-MM-YYYY hh:mm A"
                                        )}
                                      </span>
                                    )}

                                    <p>
                                      {key.notice_description.length >
                                      MAX_LENGTH ? (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              key.notice_description.substring(
                                                0,
                                                MAX_LENGTH
                                              ) + "...",
                                          }}
                                        ></div>
                                      ) : (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: key.notice_description,
                                          }}
                                        ></div>
                                      )}
                                    </p>
                                    <div className="boxActions">
                                      <span
                                        onClick={(e) =>
                                          updateNotice(
                                            "archived",
                                            key.notice_id
                                          )
                                        }
                                      >
                                        <Archive className=" " />
                                        <em>Archive</em>
                                      </span>
                                      <span
                                        onClick={handleEditNotice(
                                          "body",
                                          key.notice_id
                                        )}
                                      >
                                        <EditIcon className=" " />
                                        <em>Edit</em>
                                      </span>
                                      {key?.attachment?.length > 0 && (
                                        <span
                                          onClick={() =>
                                            viewDocs(key.notice_id, index)
                                          }
                                          className="downoadYourFile"
                                        >
                                          <FileDownloadIcon className="" />
                                          <em>Show Documents To Download </em>
                                        </span>
                                      )}
                                    </div>
                                    <div
                                      className="expandfilesDiv"
                                      id={"noticeSlideID" + index}
                                    >
                                      {key?.attachment?.length > 0 && (
                                        <>
                                          {key.attachment.map(
                                            (option, index) => (
                                              <div
                                                id="documentDiv"
                                                className="doqumentDiv1"
                                              >
                                                <a
                                                  href={option}
                                                  target="_blank"
                                                >
                                                  <div className="doquView">
                                                    {option.split(".").pop() ==
                                                    "txt" ? (
                                                      <img src={txtImage} />
                                                    ) : option
                                                        .split(".")
                                                        .pop() == "pdf" ? (
                                                      <img src={pdfImage} />
                                                    ) : option
                                                        .split(".")
                                                        .pop() == "docx" ||
                                                      option.split(".").pop() ==
                                                        "doc" ? (
                                                      <img src={wordImage} />
                                                    ) : option
                                                        .split(".")
                                                        .pop() == "xls" ||
                                                      option.split(".").pop() ==
                                                        "xlsx" ? (
                                                      <img src={excelImage} />
                                                    ) : (
                                                      <img src={option} />
                                                    )}
                                                  </div>
                                                </a>

                                                {/* <span>
                                                  <a href={option}>
                                                    {option
                                                      .split("/")
                                                      .pop()
                                                      .replace("%20", " ")}
                                                  </a>
                                                  <DoneIcon className="doneIcon" />{" "}
                                                </span> */}
                                              </div>
                                            )
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </>
                            ) : (
                              // <div className="Available">
                              //   No Notice Available....
                              // </div>
                              <div className="recordNotFound reduceSize">
                                <img src={reecordNotFound} />
                              </div>
                            )}
                          </div>
                          {/* <Grid container spacing={3} >
                            <Grid item xs={12} md={12} >
                              <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                                page={currentPage}
                                onChange={handlePageChange}
                                variant="outlined"
                                shape="rounded" />
                            </Grid>
                          </Grid> */}
                        </TabPanel>

                        {/* draft notice */}
                        <TabPanel
                          value={value}
                          index={1}
                          className="NoticeTabPanle"
                        >
                          <div className="noticeTbContDiv noticeNewMaster">
                            {noticeData.length > 0 ? (
                              <>
                                {noticeData.map((key) => (
                                  <div
                                    key={key.notice_id}
                                    className={
                                      key.notice_id === activeIndex
                                        ? "noticeTbContInner activeNotice"
                                        : "noticeTbContInner"
                                    }
                                    onClick={() => detailsNotice(key)}
                                  >
                                    {/* <Tooltip
                                      title="Download Note"
                                      arrow
                                      placement="left"
                                    >
                                      <IconButton
                                        aria-label="download"
                                        className="downloadNotice"
                                      >
                                        <DownloadIcon />
                                      </IconButton>
                                    </Tooltip> */}
                                    <p className="TicNoNotic newNotLabel">
                                      Notice No. {"N" + key.notice_id}
                                    </p>
                                    <h2>{key.notice_title}</h2>
                                    <span>
                                      {moment(key.created_at).format(
                                        "DD-MM-YYYY hh:mm A"
                                      )}
                                    </span>
                                    <p>
                                      {key.notice_description.length >
                                      MAX_LENGTH ? (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              key.notice_description.substring(
                                                0,
                                                MAX_LENGTH
                                              ) + "...",
                                          }}
                                        ></div>
                                      ) : (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: key.notice_description,
                                          }}
                                        ></div>
                                      )}
                                    </p>
                                    <TurnedInOutlinedIcon className="notiLabl" />
                                    <div className="boxActions">
                                      <span
                                        onClick={handleEditNotice(
                                          "body",
                                          key.notice_id
                                        )}
                                      >
                                        <EditIcon className=" " />
                                        <em>Edit</em>
                                      </span>
                                      <span
                                        onClick={() =>
                                          deleteNotice(key.notice_id)
                                        }
                                      >
                                        <DeleteIcon className=" " />
                                        <em>Delete</em>
                                      </span>
                                    </div>
                                  </div>
                                ))}
                              </>
                            ) : (
                              // <div className="Available">
                              //   No Notice Available....
                              // </div>
                              <div className="recordNotFound reduceSize">
                                <img src={reecordNotFound} />
                              </div>
                            )}
                          </div>
                        </TabPanel>

                        {/* archived notice */}
                        <TabPanel
                          value={value}
                          index={2}
                          className="NoticeTabPanle"
                        >
                          <div className="noticeTbContDiv noticeNewMaster">
                            {noticeData.length > 0 ? (
                              <>
                                {noticeData.map((key) => (
                                  <div
                                    key={key.notice_id}
                                    className={
                                      key.notice_id === activeIndex
                                        ? "noticeTbContInner activeNotice"
                                        : "noticeTbContInner"
                                    }
                                    onClick={() => detailsNotice(key)}
                                  >
                                    <p className="TicNoNotic newNotLabel">
                                      Notice No. {"N" + key.notice_id}
                                    </p>
                                    <h2>{key.notice_title}</h2>
                                    <span>
                                      Published on:
                                      {moment(key.created_at).format(
                                        "DD-MM-YYYY hh:mm A"
                                      )}
                                    </span>
                                    <span className="archivedDate">
                                      Archived on:{" "}
                                      {moment(key.archived_time).format(
                                        "DD-MM-YYYY hh:mm A"
                                      )}
                                    </span>
                                    <p>
                                      {key.notice_description.length >
                                      MAX_LENGTH ? (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              key.notice_description.substring(
                                                0,
                                                MAX_LENGTH
                                              ) + "...",
                                          }}
                                        ></div>
                                      ) : (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: key.notice_description,
                                          }}
                                        ></div>
                                      )}
                                    </p>
                                    <div className="boxActions">
                                      {/* <span
                                        onClick={updateNotice(
                                          "republish",
                                          key.notice_id
                                        )}
                                      >
                                        <EditIcon className=" " />
                                        <em>Republish</em>
                                      </span> */}

                                      <div className="sendNotice">
                                        <Button
                                          className="addBt"
                                          onClick={(e) =>
                                            updateNotice(
                                              "archrepublish",
                                              key.notice_id
                                            )
                                          }
                                        >
                                          RePublish
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </>
                            ) : (
                              // <div className="Available">
                              //   No Notice Available....
                              // </div>
                              <div className="recordNotFound reduceSize">
                                <img src={reecordNotFound} />
                              </div>
                            )}
                          </div>
                        </TabPanel>
                      </Box>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                          <Pagination
                            count={Math.ceil(totalItems / itemsPerPage)}
                            page={currentPage}
                            onChange={handlePageChange}
                            variant="outlined"
                            shape="rounded"
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </Grid>
                {noticeData.length > 0 && (
                  <Grid item xs={12} md={6}>
                    <div className="noticeRightCont noticeRightContSpce noticeRightContNewMaster">
                      {/* <TurnedInNotOutlinedIcon className="notiLabl2" /> */}
                      <div className="pstHead TicNo newNotLabel">
                        Notice No. {"N" + selectedItem.notice_id}
                      </div>
                      <h1>{selectedItem.notice_title}</h1>
                      {selectedItem.archived_time && status == "publish" ? (
                        <span>
                          Republished on:{" "}
                          {moment(selectedItem.created_at).format(
                            "DD-MM-YYYY hh:mm A"
                          )}
                        </span>
                      ) : (
                        <span>
                          Published on:{" "}
                          {moment(selectedItem.created_at).format(
                            "DD-MM-YYYY hh:mm A"
                          )}
                        </span>
                      )}

                      <p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: selectedItem.notice_description,
                          }}
                        ></div>
                      </p>
                      {/* {selectedItem.notice_description} */}
                      {status != "archived" ? (
                        <>
                          {showbtn && noticeData.length > 0 && (
                            <>
                              <div className="noticeCheckBox">
                                <label>Select users group</label>
                                <div
                                  className="radiobtOuter"
                                  onChange={(e) => handleChangeradio(e)}
                                >
                                  <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue="female"
                                    name="radio-buttons-group"
                                  >
                                    <FormControlLabel
                                      value="all"
                                      control={<Radio />}
                                      label="All"
                                    />
                                    <FormControlLabel
                                      value="committeeMembers"
                                      control={<Radio />}
                                      label="Committee Members"
                                    />
                                    <FormControlLabel
                                      value="allOwners"
                                      control={<Radio />}
                                      label="All Owners"
                                    />
                                    <FormControlLabel
                                      value="individual"
                                      control={<Radio />}
                                      label="Individual"
                                    />
                                  </RadioGroup>
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    {isIndividual ? (
                      <div className="visitorSearchDiv visitorSearchDivNotice">
                        <SearchIcon className="visitorSearchIco" />
                        <input
                          type="text"
                          placeholder="Search by phone or name or apartment"
                          onChangeCapture={(e) => setressearch(e.target.value)}
                        />
                        {/* <MicIcon className="visitorMicIco" /> */}
                      </div>
                    ) : (
                      <div></div>
                    )}

                    <>
                      {isIndividual ? (
                        <>
                          {/* <label className="tabsLabel absLab">Select By Keywords</label> */}
                          <div className="forNoticeSelectListOuter">
                            {residentlist.map((option) => (
                              <div
                                key={option.resident_id}
                                className={
                                  membersIds.includes(option.resident_id)
                                    ? "visitContDiv visitContDivNotice selectedTile draftSection"
                                    : "visitContDiv visitContDivNotice draftSection"
                                }
                                onClick={() =>
                                  handleChangeSelectedResident(
                                    option.resident_id
                                  )
                                }
                              >
                                <div className="visitCont1 resideNewContOut buildingNameNcountMainmini">
                                  {option.apartment ? (
                                    <>
                                      {/* {option.apartment.} */}
                                      {option.apartment.map((resApt, index) => (
                                        <>
                                          {resApt.is_current_stay == true &&
                                          option.user_type ==
                                            "Resident User" ? (
                                            // {setTempCurrentStay(true)}
                                            <div className="NewTailCountOut miniBox">
                                              <div className="buildingNameNcount">
                                                <p>
                                                  {
                                                    resApt.uniq_apt_name.split(
                                                      "/"
                                                    )[0]
                                                  }
                                                </p>
                                                <p>
                                                  {
                                                    resApt.uniq_apt_name.split(
                                                      "/"
                                                    )[1]
                                                  }
                                                </p>
                                              </div>
                                              <h1>
                                                {
                                                  resApt.uniq_apt_name.split(
                                                    "/"
                                                  )[2]
                                                }
                                              </h1>
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </>
                                      ))}
                                      {option.currentstaycnt.count == 0 &&
                                      option.user_type == "Resident User" ? (
                                        <div className="NewTailCountOut defaultTailCount miniBox">
                                          <div className="buildingNameNcount">
                                            <p>No Apart.</p>
                                            <p>Occupied</p>
                                          </div>
                                          <h1>F-000</h1>
                                        </div>
                                      ) : (
                                        <></>
                                      )}

                                      {option.user_type == "tenent" && (
                                        <>
                                          {option.apartment.map(
                                            (resApt, index) => (
                                              <div className="NewTailCountOut miniBox">
                                                <div className="buildingNameNcount">
                                                  <p>
                                                    {
                                                      resApt.uniq_apt_name.split(
                                                        "/"
                                                      )[0]
                                                    }
                                                  </p>
                                                  <p>
                                                    {
                                                      resApt.uniq_apt_name.split(
                                                        "/"
                                                      )[1]
                                                    }
                                                  </p>
                                                </div>
                                                <h1>
                                                  {
                                                    resApt.uniq_apt_name.split(
                                                      "/"
                                                    )[2]
                                                  }
                                                </h1>
                                              </div>
                                            )
                                          )}
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <div className="NewTailCountOut defaultTailCount miniBox">
                                        <div className="buildingNameNcount">
                                          <p>No Apart.</p>
                                          <p>Occupied</p>
                                        </div>
                                        <h1>F-000</h1>
                                      </div>
                                    </>
                                  )}
                                  <div className="visitContProf">
                                    {option.user_obj.profile_pic ? (
                                      <Zoom>
                                        <img
                                          src={option.user_obj.profile_pic}
                                        />
                                      </Zoom>
                                    ) : (
                                      <img alt="Remy Sharp" src={avtarPic} />
                                    )}
                                  </div>
                                  <div className="visitContLeft">
                                    <h3 className="visitContHed">
                                      {option.user_obj.first_name}{" "}
                                      {option.user_obj.last_name}{" "}
                                    </h3>
                                    <p className="visitContMob">
                                      <CallIcon className="forEmailAndPhone" />
                                      {option.user_obj.contact_no}
                                    </p>
                                  </div>
                                  {/* {option.apartment ? (
                                <div className="visitBottCont">
                                  <p>Flat Number</p>
                                  {option.apartment.map((apartmentName) => (
                                    <b>{apartmentName.uniq_apt_name} </b>
                                  ))}
                                </div>
                              ) : (
                                <div className="visitBottCont">
                                  <p>No Apartment Allocated</p>
                                </div>
                              )} */}
                                  <div className="visitBottCont forMyTexAlign">
                                    {option.apartment ? (
                                      <div>
                                        <>
                                          {option.apartment.map((opt) => (
                                            <>
                                              {(opt.is_current_stay == true ||
                                                opt.occupancy_type ==
                                                  "Vacant") &&
                                              option.user_type ==
                                                "Resident User" ? (
                                                <b className="visitContMob">
                                                  {opt.uniq_apt_name}
                                                  <em>{opt.occupancy_type}</em>
                                                  <br />
                                                </b>
                                              ) : (
                                                <></>
                                              )}

                                              {/* {(option.currentstaycnt.count == 0 && option.user_type == 'Resident User') && (
                                                  <b className="visitContMob">
                                                    vacant
                                                  </b>
                                                )} */}
                                            </>
                                          ))}
                                        </>

                                        {option.user_type == "tenent" && (
                                          <>
                                            {option.apartment.map(
                                              (opt1, index) => (
                                                <b className="visitContMob">
                                                  {opt1.uniq_apt_name}
                                                  <em>{opt1.occupancy_type}</em>
                                                </b>
                                              )
                                            )}
                                          </>
                                        )}
                                      </div>
                                    ) : (
                                      <div>No Apartment Allocated</div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </>

                    {status === "publish" && noticeData.length > 0 && (
                      <div className="sendNotice">
                        <Button
                          className="addBt"
                          onClick={(e) => updateNotice("republish", 0)}
                        >
                          RePublish
                        </Button>
                      </div>
                    )}
                    {status === "draft" &&
                      noticeData.length > 0 &&
                      (radiovalue === "all" ||
                        radiovalue === "committeeMembers" ||
                        radiovalue === "allOwners" ||
                        (radiovalue === "individual" &&
                          membersIds.length > 0)) && (
                        <div className="sendNotice">
                          <Button
                            className="addBt"
                            onClick={(e) => updateNotice("publish", 0)}
                          >
                            Publish
                          </Button>
                        </div>
                      )}
                    {/* {status != "archived" ? (
                    <>
                      {(status == "draft") ? (
                        <>
                          <div className="sendNotice">
                            <Button
                              className="addBt"
                              onClick={(e) => updateNotice("publish")}
                            >
                              Publish
                            </Button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="sendNotice">
                            <Button
                              className="addBt"
                              onClick={(e) => updateNotice("republish")}
                            >
                              RePublish
                            </Button>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <div></div>
                  )} */}
                    {/* )} */}
                  </Grid>
                )}
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>

      {/* Create New Notice */}
      <div className="modalMain">
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              setOpen(false);
            }
          }}
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Create Notice</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <CreateNoticeModal onSubmitModal={handleFormSubmit} />
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* Edit Notice */}
      <div className="modalMain">
        <Dialog
          open={open2}
          // onClose={handleClose2}
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              setOpen2(false);
            }
          }}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Edit Notice</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <CreateNoticeModal onSubmitModal={handleFormSubmit} />
            </div>
          </DialogContent>
        </Dialog>
      </div>
      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}

      <div className="modalMain">
        <Dialog
          open={openSendFor}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Members</span>
            <CloseIcon className="modalCloseBt" onClick={handleCloseSendFor} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    {sendforuser.length > 0 ? (
                      <>
                        {sendforuser.map((option) => (
                          <div className="visitContDiv visitContDivNotice draftSection">
                            {/* <div className="visitCont1 resideNewContOut buildingNameNcountMainmini">
                        <div className="NewTailCountOut miniBox">
                          <div className="buildingNameNcount">
                            <p>No Apart.</p>
                            <p>Occupied</p>
                          </div>
                          <h1>F-000</h1>
                        </div>
                        <div className="visitContProf">
                          <img src={avtarPic} />
                        </div>
                        <div className="visitContLeft">
                          <h3 className="visitContHed">Riddhi Siddhi </h3>
                          <p className="visitContMob">8728093475</p>
                        </div>
                        <div className="visitBottCont forMyTexAlign">
                          <div>No Apartment Allocated</div>
                        </div>
                      </div> */}
                            <div className="visitCont1 resideNewContOut buildingNameNcountMainmini">
                              {option.apartment ? (
                                <>
                                  {option.apartment.map((resApt, index) => (
                                    <>
                                      {resApt.is_current_stay == true &&
                                      option.user_type == "Resident User" ? (
                                        <div className="NewTailCountOut miniBox">
                                          <div className="buildingNameNcount">
                                            <p>
                                              {
                                                resApt.uniq_apt_name.split(
                                                  "/"
                                                )[0]
                                              }
                                            </p>
                                            <p>
                                              {
                                                resApt.uniq_apt_name.split(
                                                  "/"
                                                )[1]
                                              }
                                            </p>
                                          </div>
                                          <h1>
                                            {resApt.uniq_apt_name.split("/")[2]}
                                          </h1>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ))}
                                  {option.currentstaycnt.count == 0 &&
                                  option.user_type == "Resident User" ? (
                                    <div className="NewTailCountOut defaultTailCount miniBox">
                                      <div className="buildingNameNcount">
                                        <p>No Apart.</p>
                                        <p>Occupied</p>
                                      </div>
                                      <h1>F-000</h1>
                                    </div>
                                  ) : (
                                    <></>
                                  )}

                                  {option.user_type == "tenent" && (
                                    <>
                                      {option.apartment.map((resApt, index) => (
                                        <div className="NewTailCountOut miniBox">
                                          <div className="buildingNameNcount">
                                            <p>
                                              {
                                                resApt.uniq_apt_name.split(
                                                  "/"
                                                )[0]
                                              }
                                            </p>
                                            <p>
                                              {
                                                resApt.uniq_apt_name.split(
                                                  "/"
                                                )[1]
                                              }
                                            </p>
                                          </div>
                                          <h1>
                                            {resApt.uniq_apt_name.split("/")[2]}
                                          </h1>
                                        </div>
                                      ))}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  <div className="NewTailCountOut defaultTailCount miniBox">
                                    <div className="buildingNameNcount">
                                      <p>No Apart.</p>
                                      <p>Occupied</p>
                                    </div>
                                    <h1>F-000</h1>
                                  </div>
                                </>
                              )}

                              <div className="visitContProf">
                                {option.user_obj.profile_pic ? (
                                  <Zoom>
                                    <img src={option.user_obj.profile_pic} />
                                  </Zoom>
                                ) : (
                                  <img alt="Remy Sharp" src={avtarPic} />
                                )}
                              </div>
                              <div className="visitContLeft">
                                <h3 className="visitContHed">
                                  {option.user_obj.first_name}{" "}
                                  {option.user_obj.last_name}{" "}
                                </h3>
                                <p className="visitContMob">
                                  {option.user_obj.contact_no}
                                </p>
                              </div>
                              <div className="visitBottCont forMyTexAlign">
                                {option.apartment ? (
                                  <div>
                                    <>
                                      {option.apartment.map((opt) => (
                                        <>
                                          {(opt.is_current_stay == true ||
                                            opt.occupancy_type == "Vacant") &&
                                          option.user_type ==
                                            "Resident User" ? (
                                            <b className="visitContMob">
                                              {opt.uniq_apt_name}
                                              <em>{opt.occupancy_type}</em>
                                              <br />
                                            </b>
                                          ) : (
                                            <></>
                                          )}

                                          {/* {(option.currentstaycnt.count == 0 && option.user_type == 'Resident User') && (
                                                  <b className="visitContMob">
                                                    vacant
                                                  </b>
                                                )} */}
                                        </>
                                      ))}
                                    </>

                                    {option.user_type == "tenent" && (
                                      <>
                                        {option.apartment.map((opt1, index) => (
                                          <b className="visitContMob">
                                            {opt1.uniq_apt_name}
                                            <em>{opt1.occupancy_type}</em>
                                          </b>
                                        ))}
                                      </>
                                    )}
                                  </div>
                                ) : (
                                  <div>No Apartment Allocated</div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    ) : (
                      <span>No Committee Members</span>
                    )}
                  </Grid>
                  {/* <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button className="modalMainBt">Done</Button>
                    </div>
                  </Grid> */}
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default NoticeBoardPage;
